<p>az-add-speakers works!</p>
